import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useKeyDownListener from 'hooks/useKeyDownListener';
import CheckIcon from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Input from 'layout/atoms/Input/Input';
import InputLabel from 'layout/atoms/InputLabel';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { duplicateSpecification, resetSpecificationDetails, selectSpecificationDetailsStatus, selectSpecificationId, } from 'store/specificationDetailsSlice';
function DuplicateModal() {
    var _a;
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const history = useHistory();
    const [newItemCode, setNewItemCode] = useState('');
    const modalData = useSelector(selectModalByName('duplicateSpecification'));
    const specIdFromStore = useSelector(selectSpecificationId);
    const specId = (_a = modalData === null || modalData === void 0 ? void 0 : modalData.id) !== null && _a !== void 0 ? _a : specIdFromStore;
    const status = useSelector(selectSpecificationDetailsStatus);
    const handleInput = (e) => {
        setNewItemCode(e.target.value);
    };
    const handleCancel = () => {
        dispatch(closeModal({ name: 'duplicateSpecification' }));
    };
    const handleSubmit = () => {
        dispatch(duplicateSpecification({
            modelSpecificationId: specId,
            newSpecificationItemCode: newItemCode,
        }))
            .unwrap()
            .then((duplicatedSpecificationId) => {
            history.push(`/specifications/details/${duplicatedSpecificationId}`);
            dispatch(resetSpecificationDetails());
            dispatch(closeModal({ name: 'duplicateSpecification' }));
        });
    };
    useKeyDownListener([
        { code: 'Enter', callback: handleCancel },
        { code: 'Escape', callback: handleSubmit },
    ]);
    return (React.createElement(Modal, { name: "duplicateSpecification", size: "s", header: React.createElement(Label, { weight: "strong" }, t('duplicating_model')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: handleCancel }, t('common:cancel')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckIcon, null), onClick: handleSubmit, loading: status.duplicate === 'loading' }, t('duplicate'))) },
        React.createElement(InputLabel, { text: t('item_code') }),
        React.createElement(Input, { name: "newItemCode", value: newItemCode, onChange: handleInput })));
}
export default memo(DuplicateModal);
